import {mainQuery} from '@github-ui/react-core/future/main-query'
import {isFeatureEnabled} from '@github-ui/feature-flags'

import {mcpRegistryAppBuilder} from '../config/app-builder'

import type {McpRegistryResponse} from '../types'

export const mcpRegistryRoute = mcpRegistryAppBuilder.createQueryRouteConfig('mcpRegistryRoute', {
  path: '/mcp',
  queries: [
    mainQuery<McpRegistryResponse>({
      queryDeps: ({pathname, searchParams}) => {
        const isOssV01ApiEnabled = isFeatureEnabled('mcp_registry_oss_v0_1_api')
        const params = new URLSearchParams()

        if (isOssV01ApiEnabled) {
          // v0.1 API uses 'search' parameter and page-based pagination
          const search = searchParams.get('search') || ''
          const page = searchParams.get('page') || '1'

          params.set('page', page)
          if (search) params.set('search', search)
        } else {
          // v0 API uses 'q' parameter and cursor-based pagination
          const query = searchParams.get('q') || ''
          const cursor = searchParams.get('cursor') || ''
          const limit = searchParams.get('limit') || '30'

          if (cursor) params.set('cursor', cursor)
          params.set('limit', limit)
          if (query) params.set('q', query)
        }

        const pathWithParams = params.toString() ? `${pathname}?${params.toString()}` : pathname

        return {pathname: pathWithParams}
      },
    }),
  ],
})
